import React, { FC, useCallback } from 'react';
import { normalizeChoices } from 'model/menu';
import { openModifierModal } from 'data/cacheHelpers/menu';
import { Container, MainText, Text, Fragment } from './styles';
import { Props } from './types';

const Modifier: FC<Props> = ({ brandId, modifier, ...props }) => {
  const { name, items, choices, usedIn } = modifier;
  const { type, selection } = normalizeChoices(choices, items.length);

  const openEditModifierModal = useCallback(
    () => openModifierModal({ brandId, modifier }),
    [brandId, modifier],
  );

  return (
    <Container {...props} onClick={openEditModifierModal}>
      <Fragment>
        <MainText>{name}</MainText>
      </Fragment>

      <Fragment>
        <Text>{type}</Text>
      </Fragment>

      <Fragment>
        <Text>{selection}</Text>
      </Fragment>

      <Fragment>
        <Text>{items.length}</Text>
      </Fragment>

      <Fragment>
        <MainText>{usedIn.length} items</MainText>
      </Fragment>
    </Container>
  );
};

export default Modifier;
